<template>
  <div class="inventory-criteria-qty">
    <div class="inventory">
      INVENTORY
    </div>
    <div class="input-section d-flex">
      <select
        v-model="selectedCriteria"
        class="criteria px-1"
        :disabled="isAvailabilityEmpty"
      >
        <option value="set">
          Set Criteria
        </option>
        <option value=">=">
          = or >
        </option>
        <option value="<=">
          = or <
        </option>
        <option value="clear">
          Clear Criteria
        </option>
      </select>

      <input
        v-model.number="qty"
        type="number"
        class="qty"
        placeholder="Qty"
        :disabled="isAvailabilityEmpty || isCriteriaSelected"
        @keyup.enter="$event.target.blur()"
        @blur="$emit('inventoryInputBlurred', qty)"
      >
    </div>
  </div>
</template>

<script>
export default {
  name: 'InventoryCriteriaQuantityInput',
  props: {
    criteria: {
      type: String,
      default: 'set'
    },
    quantity: {
      type: String,
      default: null
    },
    isAvailabilityEmpty: {
      type: Boolean,
      default: false
    }
  },
  data: () => ({
    selectedCriteria: 'set',
    qty: null
  }),
  computed: {
    isCriteriaSelected () {
      return (this.selectedCriteria === 'clear' || this.selectedCriteria === 'set')
    }
  },
  watch: {
    criteria (val) {
      this.selectedCriteria = val
    },
    quantity (val) {
      if (val < 0) {
        val = this.getAbs(val)
      }
      this.qty = val
    },
    selectedCriteria (val) {
      if (val === 'clear' || val === 'set') {
        this.qty = null
        this.$emit('inventoryInputBlurred', null)
      }
      if (val < 0) {
        val = this.getAbs(val)
      }
      this.$emit('inventoryDropdownChange', val)
    }
  },
  mounted () {
    this.selectedCriteria = this.criteria
    if (this.quantity < 0) {
      this.qty = this.getAbs(this.quantity)
    } else {
      this.qty = this.quantity
    }
  },
  methods: {
    getAbs (val) {
      return Math.abs(val)
    }
  },
}
</script>

<style lang="scss" scoped>
.inventory-criteria-qty {
    .inventory {
        text-align: left;
        font: normal normal bold 14px/16px Arial;
        letter-spacing: 0px;
        color: #383838;
        margin-bottom: 9px;
    }

    .input-section {
        .criteria {
            color: #898989;
            max-width: 104px;
            width: 100%;
            height: 26px;
            background: #FFFFFF 0% 0% no-repeat padding-box;
            border: 0.9999761581420898px solid #707070;
            margin-right: 8px;
            text-align: left;
            font: italic normal normal 12px/14px Arial;
            letter-spacing: 0px;
        }
        .criteria:focus-visible {
          outline: none;
        }

        .qty {
            width: 38px;
            height: 26px;
            background: #FFFFFF 0% 0% no-repeat padding-box;
            border: 0.9999761581420898px solid #707070;
            text-align: center;
            -moz-appearance: textfield;

            &::-webkit-outer-spin-button,
            &::-webkit-inner-spin-button {
                -webkit-appearance: none;
                margin: 0;
                display: none;
            }

            &::placeholder {
                text-align: center;
                font: italic normal normal 12px/14px Arial;
                letter-spacing: 0px;
                color: #898989;
            }
        }
    }
}
</style>
